import CardTemplateCreatorMasterView from './CardTemplateCreatorMasterView';

export default CardTemplateCreatorMasterView;
